import { useState, useMemo } from 'react'
import { applyFilters, extractFilterValues, splitByStatus } from '../utils/filters'

const useTaskFilters = (data) => {
  const [searchText, setSearchText] = useState('')
  const [statusFilter, setStatusFilter] = useState('all')
  const [priorityFilter, setPriorityFilter] = useState('all')
  const [categoryFilter, setCategoryFilter] = useState('all')
  const [dateRange, setDateRange] = useState(null)

  // Extract filter values from data
  const filterValues = useMemo(() => extractFilterValues(data), [data])

  // Apply filters to data
  const filteredData = useMemo(() => {
    return applyFilters(data, {
      searchText,
      statusFilter,
      priorityFilter,
      categoryFilter,
      dateRange
    })
  }, [data, searchText, statusFilter, priorityFilter, categoryFilter, dateRange])

  // Split filtered data by status
  const { pendingTasks, completedTasks } = useMemo(() => {
    return splitByStatus(filteredData)
  }, [filteredData])

  return {
    // Filter values
    filterValues,
    // Filter states
    searchText,
    setSearchText,
    statusFilter,
    setStatusFilter,
    priorityFilter,
    setPriorityFilter,
    categoryFilter,
    setCategoryFilter,
    dateRange,
    setDateRange,
    // Filtered data
    filteredData,
    pendingTasks,
    completedTasks
  }
}

export default useTaskFilters
